import React, { useState } from "react";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AccountList, AddEditAccount } from "../../components/account";
import { CREATE_ACCOUNT } from "../../constants";
import { useHasPermission } from "../../utils";

export const Accounts = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const hasAccountCreate = useHasPermission(CREATE_ACCOUNT);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hasAccountCreate && {
      buttonText: "Add Account",
      buttonIcon: Add,
      onClick: handleOpenModal,
    },
  ];

  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader
            // title
            title="Accounts"
            subtitle={`${totalCount} Accounts`}
            // button
            buttons={buttons}
          />
        </Box>

        {/* table section */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <AccountList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
        </Box>
      </PageLayout>

      {/* add account modal */}
      <AddEditAccount open={openModal} onClose={handleCloseModal} onSuccess={handleReload} />
    </>
  );
};
